// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editr .editr--toolbar{display:none}.editr .editr--content{font-size:13px;padding:12px 15px;min-height:auto}.editr .editr--content p{margin:0;padding:0}", ""]);
// Exports
module.exports = exports;
